"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationAutoSuggestFields = void 0;
var NotificationAutoSuggestFields;
(function (NotificationAutoSuggestFields) {
    NotificationAutoSuggestFields["TITLE"] = "title";
    NotificationAutoSuggestFields["BODY"] = "body";
    NotificationAutoSuggestFields["IMAGE_URL"] = "image_url";
    NotificationAutoSuggestFields["KEYWORDS"] = "keywords";
})(NotificationAutoSuggestFields = exports.NotificationAutoSuggestFields || (exports.NotificationAutoSuggestFields = {}));
//# sourceMappingURL=notification-auto-suggest-fields.js.map